/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Share_LinkInputs */

const en_tts_tool_share_link = /** @type {(inputs: Tts_Tool_Share_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy audio link`)
};

const es_tts_tool_share_link = /** @type {(inputs: Tts_Tool_Share_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar enlace de audio`)
};

/**
* | output |
* | --- |
* | "Copy audio link" |
*
* @param {Tts_Tool_Share_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_share_link = /** @type {((inputs?: Tts_Tool_Share_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Share_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_share_link(inputs)
	return en_tts_tool_share_link(inputs)
});